'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleDialog = require('./SimpleDialog');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SimpleDialog).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }